import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { FilteredTreeElement, TreeElement } from "./osxtreeview.model";

//DONE scroll right after click
//HACKY fix scroll container
//TODO search box

@Component({
    name: 'OSXTreeView',
})
export default class OSXTreeView extends Vue {
    @Prop({ required: true })
    readonly items!: TreeElement<any, any>[];
    @Prop({ default: {} })
    readonly styling!: {
        'max-width'?: any,
    };
    @Prop({ default: "13em" })
    readonly columnWidth!: string;

    //runtime
    private readonly path: number[] = []; //id array with id from items
    private lastSelected: number | null = null;
    private initialWidth: string = 'unset';
    private search: string = '';

    mounted(): void {
        this.initialWidth = '' + this.$el.clientWidth;
    }

    public clearSelection(): void {
    }

    private click($event: MouseEvent, item: FilteredTreeElement<any, any, any>): void {
        let ctrl = $event.ctrlKey;//deselect on ctrl key and element selected
        let deselect = false;

        //dont pop/push when already in path
        if (this.path.includes(item.id)) {
            if (ctrl) {
                deselect = true;
            } else {
                return;
            }
        } else if (ctrl) {
            return;
        }

        // pop path
        this.lastSelected = null;
        if (item.parent === null) {
            this.path.splice(0);
        } else {
            for (let i = this.path.length - 1; i >= 0; i--) {
                if (item.parent.id !== this.path[i]) {
                    this.path.splice(i);
                } else {
                    break;
                }
            }
        }

        if (!deselect) {
            //push path
            this.path.push(item.id);

            //scroll into view
            if (item.children.length > 0) {
                this.$nextTick(() => {
                    let container = this.$refs.scrollcontainer as HTMLElement;
                    container.scrollTo({ left: container.clientWidth });
                });
            }
            this.lastSelected = item.id;
            this.$emit('selected', item.item);
        } else {
            let pathElements = this.pathElements;
            let selected = pathElements.length > 0 ? pathElements[pathElements.length - 1].item : null;
            this.lastSelected = selected ? selected.id : null;
            this.$emit('selected', selected);
        }
    }

    private mixedStyle(): any {
        let ret = Object.assign({}, {
            'max-width': this.initialWidth + 'px',
            //default styles in here
        }, this.styling);
        return ret;
    }

    private get mixedStyleWOHeight(): any {
        let ms = this.mixedStyle();
        delete ms['max-height'];
        delete ms['height'];
        return ms;
    };

    private get mixedStyleHeight(): any {
        let ms = this.mixedStyle();
        return { 'max-height': ms['max-height'], height: ms['height'] };
    };

    private get filteredItems(): FilteredTreeElement<any, any, any>[] {
        let l = this.items.map(i => new FilteredTreeElement<any, any, any>(i, null));
        this.applyFilter(l);
        return l;
    }

    private applyFilter(items: FilteredTreeElement<any, any, any>[]): void {
        if (this.search.trim().length === 0) {
            items.forEach(i => i.visible = true);
            return;
        }
        items.forEach(i => {
            this.applyFilter(i.children);
            i.visible = i.searchableText.toLocaleLowerCase().includes(this.search.toLocaleLowerCase())
                || i.children.some(e => e.visible);
        });
    }

    private get pathElements(): FilteredTreeElement<any, any, any>[] {
        let ret: FilteredTreeElement<any, any, any>[] = [];
        let filteredItems = this.filteredItems;
        for (let i = 0; i < this.path.length; i++) {
            let item = filteredItems.find(fi => fi.id == this.path[i])!;
            ret.push(item);
            filteredItems = item.children;
        }
        return ret;
    }

    //watches
    @Watch('search')
    private pathCollapser(): void {
        this.$nextTick(() => {
            let pathElements = this.pathElements;
            for (let i = 0; i < this.path.length; i++) {
                if (!pathElements[i].visible) {
                    this.path.splice(i);
                    return;
                }
            }
        });
    }
}